import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';

import { NotificacionApiService } from '../../../core/services/notificacion-api.service';

@Component({
    selector: 'app-contacto-estatico',
    templateUrl: './contacto-estatico.component.html',
    styleUrls: ['./contacto-estatico.component.scss'],
    standalone: false
})
export class ContactoEstaticoComponent implements OnInit {

  contacto!: FormGroup;
  submitted = false;
  mensaje: string = '';
  mensajeStyle: string = '';

  nombre:string = '';
  apellido:string = '';
  empresa:string = '';
  cargo:string = '';
  movil:string = '';
  correo:string = '';
  ubicacion:string = '';
  cotiza:string = '';
  descripcion:string = '';

  urlActual: string = '';

  constructor(private router: Router, private formBuilder: FormBuilder, private notificacionApiService: NotificacionApiService) {
    this.urlActual = router.url;
  }

  ngOnInit(): void {
    this.contacto = this.formBuilder.group({
        nombre: ['', Validators.required],            
        apellido: ['', [Validators.required]],
        empresa: ['', Validators.required],
        movil: ['', Validators.required],
        cargo: ['', Validators.required],
        correo: ['', Validators.required],
        ubicacion: ['', Validators.required],
        cotiza: ['', Validators.required],
        descripcion: ['', Validators.required]
    });
  }

  get f() {return this.contacto.controls; }

  onSubmit() {
    this.submitted = true;
 
    if(this.contacto.invalid) {
      
    } else {
      this.notificacionApiService.postEnviaEmailContacto(
        (this.nombre + ' ' + this.apellido), 
        this.empresa, 
        this.cargo, 
        this.movil, 
        this.correo,
        this.ubicacion, 
        this.cotiza, 
        this.descripcion).subscribe(
        (data: []) => {
          // let _response: any = data;
          this.mensaje = 'Gracias por pornerte en contacto con nosotros.';
          this.mensajeStyle = 'success'
        },(error: {}) => {
          console.error("error");
          this.mensaje = 'Problemas con el envío de la notificación.';
          this.mensajeStyle = 'danger';
        }
      );  
    }
  }

}
